import { cacheScrollPosition } from '@/utils/dom'
import { motion, useMotionValueEvent, useScroll } from 'motion/react'
import { useRef } from 'react'

interface ScrollListProps {
	children: React.ReactNode
	onLoadMore?: () => Promise<void>

	threshold?: number
}

function ScrollList({ children, onLoadMore, threshold = 0.8 }: ScrollListProps) {
	const loadingRef = useRef(false)
	const containerRef = useRef<HTMLDivElement>(null)

	// 使用 useScroll 监听滚动
	const { scrollY, scrollYProgress } = useScroll()

	// 监听滚动位置并触发加载更多
	useMotionValueEvent(scrollYProgress, 'change', (progress: number) => {
		// 保存滚动位置
		cacheScrollPosition(scrollY.get())

		// 检查是否需要加载更多
		if (loadingRef.current || !onLoadMore || progress < threshold) return

		loadingRef.current = true
		onLoadMore().finally(() => {
			loadingRef.current = false
		})
	})

	return <motion.div ref={containerRef}>{children}</motion.div>
}

export default ScrollList
